import React, { useEffect, useState } from "react";

import Calculate_Personal_Loan_Emi from "../Common_Component/Calculate_Personal_Loan_Emi/Calculate_Personal_Loan_Emi";

import Second_Header from "../Common_Component/Second_Header/Second_Header";
import Cookies from "js-cookie";
const Eligibilty_Calculator = () => {
  const [data, setData] = useState(false);

  const user_data = Cookies.get("user_data"); // Get the value of 'status' cookie

  useEffect(() => {
    if (user_data) {
      const parsedData = JSON.parse(user_data);
      setData(parsedData);
    }
  }, [user_data]);
  return (
    <section className="Eligibilty_Calculator">
      <div className="second_h_holder">
        <Second_Header
          data={data}
          setData={setData}
          showCompare={false}
          showFilter={false}
        />
      </div>

      <div className="calculator_holder">
        <Calculate_Personal_Loan_Emi />
      </div>
    </section>
  );
};

export default Eligibilty_Calculator;
